<template>
  <div class="aftersales_main">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="退货退款" name="first"></el-tab-pane>
      <el-tab-pane label="换货" name="second"> </el-tab-pane>
    </el-tabs>
    <div class="info-box">
      <el-form :inline="true" :model="form">
        <el-form-item label="采销状态：">
          <el-select v-model="form.PurchaseSaleStatus">
            <el-option :value="-1" label="全部"></el-option>
            <el-option :value="0" label="待审核"></el-option>
            <el-option :value="1" label="通过待提交"></el-option>
            <el-option :value="2" label="通过"></el-option>
            <el-option :value="3" label="拒绝"></el-option>
            <el-option :value="4" label="通过已提交"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单号：">
          <el-input v-model="form.OrderNo" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="申请人：">
          <el-input v-model="form.ApplyUser" placeholder="请输入内容"></el-input>
        </el-form-item>
        <el-form-item label="处理状态：">
          <el-select v-model="form.HandleStatus">
            <el-option :value="-1" label="全部"></el-option>
            <el-option :value="0" label="待处理"></el-option>
            <el-option :value="1" label="进行中"></el-option>
            <el-option :value="2" label="已完成"></el-option>
            <el-option :value="3" label="已取消"></el-option>
            <el-option :value="4" label="已拒绝"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="财务状态：">
          <el-select v-model="form.FinanceStatus">
            <el-option :value="-1" label="全部"></el-option>
            <el-option :value="0" label="待审核"></el-option>
            <el-option :value="1" label="已通过"></el-option>
            <el-option :value="2" label="已拒绝"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户退款状态：">
          <el-select v-model="form.RefundStatus">
            <el-option :value="-1" label="全部"></el-option>
            <el-option :value="0" label="未退款"></el-option>
            <el-option :value="1" label="已退款"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="供应商回款状态：">
          <el-select v-model="form.SupReturnPayStatus">
            <el-option :value="-1" label="全部"></el-option>
            <el-option :value="0" label="未处理"></el-option>
            <el-option :value="1" label="余额抵扣"></el-option>
            <el-option :value="2" label="打款退款"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间：">
          <el-select v-model="form.orderStatus">
            <el-option :value="-1" label="申请时间"></el-option>
            <el-option :value="10" label="采销审核时间"></el-option>
            <el-option :value="20" label="资料提交时间"></el-option>
            <el-option :value="20" label="财务审核时间"></el-option>
            <el-option :value="20" label="回款确认时间"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-date-picker
            v-model="valueTime"
            type="datetimerange"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            @change="handlePicker"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">筛选</el-button>
          <el-button @click="onEmpty">清空</el-button>
        </el-form-item>
      </el-form>
      <div class="tool_box">
        <toolbar :buttonList="buttonList_toolBar" @callFunction="callFunction"></toolbar>
      </div>
      <el-card>
        <el-table
          :data="orderList"
          border
          style="width: 100%"
          v-loading="loading"
          element-loading-text="拼命加载中"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
          :span-method="arraySpanMethod"
          :cell-class-name="setCellStyle"
        >
          <el-table-column label="处理状态" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.HandleStatus == 0">待处理</span>
              <span v-else-if="scope.row.HandleStatus == 1">进行中</span>
              <span v-else-if="scope.row.HandleStatus == 2">已完成</span>
              <span v-else-if="scope.row.HandleStatus == 3">已取消</span>
              <span v-else-if="scope.row.HandleStatus == 4">已拒绝</span>
              <span v-else>/</span>
            </template>
          </el-table-column>
          <el-table-column label="审批状态" align="center" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.BusinessStatus == 0">待审核</span>
              <span v-else-if="scope.row.BusinessStatus == 1">通过</span>
              <span v-else-if="scope.row.BusinessStatus == 2">拒绝</span>
              <span v-else-if="scope.row.BusinessStatus == 3">完成</span>
              <span v-else-if="scope.row.BusinessStatus == 4">关闭</span>
            </template>
          </el-table-column>
          <el-table-column label="订单信息" align="center" width="300">
            <template slot-scope="scope">
              <div style="text-align:left;">
                <p>订单号：{{scope.row.ChildOrderNo}}
                  <el-tag size="mini" type="danger" v-if="scope.row.IsBlockedOrder">黑名单</el-tag>
                </p>
                <p>订单状态：{{scope.row.Status | orderStatusName}}</p>
                <p>商品名称：{{scope.row.SkuName}}</p>
                <p>会员账号：{{scope.row.CustomerUserName}}
                  <el-tag size="mini" type="danger" v-if="scope.row.IsBlockedBusinesses">黑名单</el-tag>
                </p>
                <p>名称：{{scope.row.CustomerNickName}}</p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="申请数量" prop="applySkuNumber" align="center" width="120"></el-table-column>
          <el-table-column label="金额合计" align="center" width="140">
            <template slot-scope="scope">
              <span>￥{{scope.row.refundAmount}}</span>
            </template>
          </el-table-column>
          <el-table-column label="运维备注" align="center" width="140">
            <template slot-scope="scope">
              <span style="color:#f40000;" v-if="scope.row.BusinessRemark">{{scope.row.BusinessRemark}}</span>
              <span v-else>/</span>
            </template>
          </el-table-column>
          <el-table-column label="换货类型" align="center" width="141">
            <template slot-scope="scope">
              <el-table border :data="scope.row.SupList" :show-header="false">
                <el-table-column label="换货类型" prop="ExchangeTypeName" align="center" width="140"></el-table-column>
                <el-table-column label="采购供应商" prop="SupName" align="center" width="200"></el-table-column>
                <el-table-column label="资料提交状态" align="center" width="120">
                  <template slot-scope="scope2">
                    <span v-if="!scope2.row.IsDataSubmit">待提交</span>
                    <span v-else-if="scope2.row.IsDataSubmit">已提交</span>
                    <span v-else>/</span>
                  </template>
                </el-table-column>
                <el-table-column label="退回物流" align="center" width="200">
                  <template slot-scope="scope2">
                    <div v-if="scope2.row.ReturnLogistics">
                      <div v-for="(item1, index1) in scope2.row.ReturnLogistics" :key="index1">
                        {{item1.ShortName}}{{item1.LogisticsCode}}
                      </div>
                    </div>
                    <span v-else>/</span>
                  </template>
                </el-table-column>
                <el-table-column label="换货物流" align="center" width="200">
                  <template slot-scope="scope2">
                    <div v-if="scope2.row.ExchangeLogistics">
                      <div v-for="(item1, index1) in scope2.row.exchangeLogistics" :key="index1">
                        {{item1.ShortName}}{{item1.LogisticsCode}}
                      </div>
                    </div>
                    <span v-else>/</span>
                  </template>
                </el-table-column>
                <el-table-column label="运费" prop="freight" align="center" width="120"></el-table-column>
                <el-table-column label="承担方" align="center" width="140">
                  <template slot-scope="scope2">
                    <span v-if="scope2.row.BearFreight == 1">营客通承担</span>
                    <span v-else-if="scope2.row.BearFreight == 2">客户承担</span>
                    <span v-else-if="scope2.row.BearFreight == 3">供应商承担</span>
                    <span v-else-if="scope2.row.BearFreight == 4">无需运费</span>
                    <span v-else>/</span>
                  </template>
                </el-table-column>
                <el-table-column label="资料提交" align="center" width="100">
                  <template slot-scope="scope2">
                    <el-button type="text" size="mini" v-if="scope2.row.IsNeedSubmitData && !scope2.row.IsDataSubmit" @click="openInfoDialog(scope2.row)">提交资料</el-button>
                    <span v-else>/</span>
                  </template>
                </el-table-column>
                <el-table-column label="物流信息" align="center" width="199">
                  <template slot-scope="scope2">
                    <el-button type="primary" size="mini" @click="backLogistic(scope2.row, scope.row)">退回物流</el-button>
                    <el-button type="primary" size="mini" @click="exchangeLogistic(scope2.row, scope.row)">换货物流</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="采购供应商" align="center" prop="ChildOrderNo" width="200"></el-table-column>
          <el-table-column label="资料提交状态" align="center" prop="Amount" width="120"></el-table-column>
          <el-table-column label="退回物流" align="center" width="200" prop="SkuName"></el-table-column>
          <el-table-column label="换货物流" align="center" width="200"></el-table-column>
          <el-table-column label="运费" align="center" width="120"></el-table-column>
          <el-table-column label="承担方" align="center" width="140"></el-table-column>
          <el-table-column label="资料提交" align="center" width="100"></el-table-column>
          <el-table-column label="物流信息" align="center"  width="200"></el-table-column>
          <el-table-column label="操作情况" align="center" width="300">
            <template slot-scope="scope">
              <div style="text-align:left;">
                <p v-for="(item, index) in scope.row.TrackList" :key="index">
                  <span>{{item.Description}}</span>&nbsp;&nbsp;<span>{{item.CreateTime}}</span>&nbsp;&nbsp;<span>{{item.OperatorName}}</span>
                </p>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作" fixed="right" align="center" width="200">
            <template slot-scope="scope">
              <el-button
                v-for="button in buttonList_table"
                :key="button.id"
                size="small"
                :type="button.Func&&button.Func.toLowerCase().indexOf('del')!= -1 ? 'danger':button.Func&&button.Func.toLowerCase().indexOf('edit')!= -1?'primary':'success'"
                @click="callFunctionRow(button, scope.$index, scope.row)"
              >{{button.name}}</el-button>
              <el-button style="margin-bottom:10px;" size="mini" type="success" v-if="scope.row.businessStatus == 0" @click="passBtn(scope.row)">通过</el-button>
              <el-button style="margin-bottom:10px;" size="mini" type="danger" v-if="scope.row.businessStatus == 0" @click="refuseBtn(scope.row)">拒绝</el-button>
              <el-button style="margin-bottom:10px;" size="mini" type="primary" v-if="scope.row.auditStatus == 0 && scope.row.BusinessStatus == 1" @click="submitApproval(scope.row)">提交审批</el-button>
              <el-button style="margin-bottom:10px;" size="mini" type="warning" v-if="scope.row.auditStatus == 1 && scope.row.FinanceStatus == 0" @click="cancelBtn(scope.row)">取消</el-button>
              <span>
                <el-button size="mini" type="primary" style="margin-bottom:10px;" v-if="(scope.row.thiredOrderType >= 7 && scope.row.thiredOrderType <= 11) && scope.row.businessStatus == 1" @click="keplerCancelBtn(scope.row)">开普勒售后</el-button>
              <el-button size="mini" type="primary" style="margin-bottom:10px;"
                         v-if="(scope.row.thiredOrderType == 1 && scope.row.isJDVopCanApplyAfs) && scope.row.businessStatus == 1"
                         @click="keplerCancelBtn(scope.row)">慧采售后</el-button>
              </span>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          :total="total"
          @current-change="handleCurrentChange"
          style="float:right;"
        ></el-pagination>
      </el-card>
    </div> 
    <!-- 通过 -->
    <el-dialog
    title="通过"
    v-if="refundVisible"
    :visible.sync="refundVisible"
    :close-on-click-modal="false">
      <div>
        <div v-if="afterSaleOrderSup[0]">
          <div class="btm">该订单包含多供应商，请选择对应退货的渠道：</div>
          <div class="btm">所需换货数量：{{applySkuNumber}}</div>
          <div>
            <ul>
              <li class="item-sup" v-for="(item1, index1) in afterSaleOrderSup" :key="index1">
                <div class="item-sup-l">
                  <el-checkbox @change="value => {handleSupbox(value, item1)}"></el-checkbox>
                </div>
                <div class="item-sup-r">
                  <div class="btm"><span>{{item1.BuySupplierName}}</span></div>
                  <div class="btm">换货数量：<el-input size="mini" style="width:100px;" v-model="item1.DeliveredNumber"></el-input></div>
                  <div v-for="(item2, index2) in item1.ChildLogistics" :key="index2">
                    <div class="btm"><span class="mar-r">{{item2.LogisticsCompanyName}} {{item2.LogisticsCode}}</span><span>数量：{{item2.SendSkuNumber}}台</span></div>
                  </div>
                  <div class="btm">
                    <span>运费：</span>
                    <el-radio-group v-model="item1.BearFreight" @change="(value) => handleRadio(value, item1)">
                      <el-radio :label="1">营客通承担</el-radio>
                      <el-radio :label="2">客户承担</el-radio>
                      <el-radio :label="3">供应商承担</el-radio>
                      <el-radio :label="4">无需运费</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="btm">
                    <span class="mar-r">金额：<el-input size="mini" style="width:100px;" v-model="item1.Freight"></el-input></span>
                  </div>
                  <div class="btm">
                    <span>换货类型：</span>
                    <el-radio-group v-model="item1.ExchangeType" @change="(value) => handleExchangeType(value, item1)">
                      <el-radio :label="1">原供应商换货</el-radio>
                      <el-radio :label="2">换供应商采</el-radio>
                      <el-radio :label="3">换型号</el-radio>
                      <el-radio :label="4">先买后退</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="btm" v-if="item1.ExchangeType == 3">
                    <span>更换型号：</span>
                    <el-input v-model="item1.ExchangeModelCode"></el-input>
                  </div>
                  <div class="btm">
                    <span>是否需要提交资料：</span>
                    <el-radio-group v-model="item1.IsNeedSubmitData">
                      <el-radio :label="true">是</el-radio>
                      <el-radio :label="false">否</el-radio>
                    </el-radio-group>
                  </div>
                  <div class="btm">
                    <span style="vertical-align: top;">备注：</span>
                    <el-input type="textarea" v-model="item1.Remark"></el-input>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
        <div v-else>该订单还未采购可直接提交！</div>
      </div>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="submitAfter">提交</el-button>
      </div>
    </el-dialog>
    <!-- 提交资料 -->
    <el-dialog
    title="提交资料"
    width="30%"
    :visible.sync="dialogInfoVisible"
    :close-on-click-modal="false">
      <el-form label-width="140px">
        <el-form-item label-width="0px">
          <div style="display:flex;justify-content: space-around;">
            <div class="img-box">
              <el-upload
                class="el_upload"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="value => handleChange(value, 1)"
              >
                <img
                  v-if="infoForm.inspectionSheePic"
                  :src="infoForm.inspectionSheePic"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <span class="mask" v-if="infoForm.inspectionSheePic">
                  <span
                    @click.stop="delPic(1)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </el-upload>
              <p>检验单</p>
            </div>
            <div class="img-box">
              <el-upload
                class="el_upload"
                action="#"
                :auto-upload="false"
                :show-file-list="false"
                :on-change="value => handleChange(value, 2)"
              >
                <img
                  v-if="infoForm.supReceiptPic"
                  :src="infoForm.supReceiptPic"
                  class="avatar"
                />
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                <span class="mask" v-if="infoForm.supReceiptPic">
                  <span
                    @click.stop="delPic(2)"
                  >
                    <i class="el-icon-delete"></i>
                  </span>
                </span>
              </el-upload>
              <p>供应商收货单（必传）</p>
            </div>
          </div>
        </el-form-item>
        <el-form-item label="供应商退款方式：">
          <el-radio-group v-model="infoForm.supReturnPayMode">
            <el-radio :label="1">余额抵扣</el-radio>
            <el-radio :label="2">打款退款</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="外部订单号：">
          <el-input v-model="infoForm.externalOrderId"></el-input>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input type="textarea" v-model="infoForm.remark"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="submitInfo">提交</el-button>
      </div>
    </el-dialog>
    <!-- 退回物流 -->
    <el-dialog
    :title="dialogTitle"
    :visible.sync="dialogBackLogistic"
    :close-on-click-modal="false">
      <el-form label-width="120px">
        <el-form-item label="物流公司：">
          <el-select
            v-model="logisticForm.logisticsCompanyId"
            placeholder="请选择物流公司"
            filterable
          >
            <el-option
              v-for="(item, index) in logisticsList"
              :key="index"
              :label="item.ShortName"
              :value="item.Id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="物流单号：">
          <el-input v-model.trim="logisticForm.logisticsCode"></el-input>
        </el-form-item>
        <el-form-item label="数量：">
          <el-input v-model.number="logisticForm.number"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-preventClick @click="submitLogistic">提交</el-button>
        </el-form-item>
        <el-form-item label-width="0">
          <el-table border :data="logisticRecord">
            <el-table-column label="物流公司" prop="ShortName" align="center"></el-table-column>
            <el-table-column label="物流单号" prop="LogisticsCode" align="center"></el-table-column>
            <el-table-column label="数量" prop="Number" align="center"></el-table-column>
          </el-table>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 开普勒售后 -->
    <el-dialog title="开普勒申请售后" :visible.sync="dialogCtpVisible1" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="售后数量：">
          <el-input v-model.number="applyCtpForm.quantity"></el-input>
        </el-form-item>
        <el-form-item label="售后类型：">
          <el-select v-model="applyCtpForm.afsType" @change="changeAfsType">
            <el-option v-for="(item, index) in ctpAfterSaleType" :key="index" :value="item.afsType" :label="item.afsTypeName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后原因：">
          <el-select v-model="applyCtpForm.applyReasonId" value-key="ApplyReasonId" @change="changeCtpReason">
            <el-option v-for="(item, index) in ctpAfterSaleReason" :key="index" :value="item" :label="item.ApplyReasonName"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="问题描述图片：" v-if="applyCtpForm.needUploadPic">
          <draggable
            :list="PicInfoList"
            :group="{ sort: true, animation: 500 }"
          >
            <div
              class="img_box"
              v-for="(item, index) in PicInfoList"
              :key="index"
            >
              <p class="del_box" @click.stop="handleDelPic(index)">
                <img src="../../../assets/del-icon.png" alt />
              </p>
              <img
                :src="item"
                alt
                @click.stop="handleBigPic(item)"
              />
            </div>
            <el-upload
              class="avatar-uploader border-one"
              action
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleBusinessPic"
              multiple
            >
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="是否收到货：">
          <el-radio-group v-model="applyCtpForm.isReceived">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="取件方式：">
          <el-select v-model="applyCtpForm.pickWareType">
            <el-option :value="4" label="上门取件"></el-option>
            <el-option :value="8" label="大家电上门取件"></el-option>
            <el-option :value="40" label="客户发货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="收货地区:">
        <!-- 省 -->
        <el-select
          v-model="provinceName"
          placeholder="请选择省"
          @change="handleProvince"
          style="width: 150px;"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.Id"
            :label="item.AreaName"
            :value="item"
          ></el-option>
        </el-select>
        <!-- 市 -->
        <el-select v-model="cityName" placeholder="请选择市" @change="handleCity" style="width: 150px;">
          <el-option v-for="item in cityList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
        </el-select>
        <!-- 区 -->
        <el-select v-model="countyName" placeholder="请选择区" @change="handleArea" style="width: 150px;">
          <el-option v-for="item in areaList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
        </el-select>
        <!-- 街道 -->
        <el-select
          v-model="townName"
          placeholder="请选择街道"
          @change="handleStreet"
          style="width: 150px;"
        >
          <el-option v-for="item in streetList" :key="item.Id" :label="item.AreaName" :value="item"></el-option>
        </el-select>
        </el-form-item>
        <el-form-item label="收货地址：">
          <el-input v-model="applyCtpForm.address" style="width: 270px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="submitCtpAfterSale">提交</el-button>
      </div>
    </el-dialog>
    <!-- 京东慧采售后 -->
    <el-dialog title="京东慧采申请售后" :visible.sync="dialogCtpVisible3" :close-on-click-modal="false">
      <el-form>
        <el-form-item label="售后数量：">
          <el-input v-model.number="applyJDHCForm.SkuNum"></el-input>
        </el-form-item>
        <el-form-item label="售后类型：">
          <el-select v-model="applyJDHCForm.CustomerExpect">
            <el-option v-for="(item, index) in jdhcAfterSaleType" :key="index" :value="item.value"
                       :label="item.title"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="售后问题描述：">
          <el-input v-model="applyJDHCForm.QuestionDesc"></el-input>
        </el-form-item>
        <el-form-item label="是否需要检测报告：">
          <el-radio-group v-model="applyJDHCForm.IsNeedDetectionReport">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="问题描述图片：" v-if="applyJDHCForm.QuestionPic">
          <draggable :list="PicInfoList"
                     :group="{ sort: true, animation: 500 }">
            <div class="img_box"
                 v-for="(item, index) in PicInfoList"
                 :key="index">
              <p class="del_box" @click.stop="handleDelPic(index)">
                <img src="../../../assets/del-icon.png" alt/>
              </p>
              <img :src="item"
                   alt
                   @click.stop="handleBigPic(item)"/>
            </div>
            <el-upload class="avatar-uploader border-one"
                       v-if="PicInfoList.length<3"
                       action
                       :show-file-list="false"
                       :auto-upload="false"
                       :on-change="handleBusinessPic"
                       multiple>
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </draggable>
        </el-form-item>
        <el-form-item label="是否有包装：">
          <el-radio-group v-model="applyJDHCForm.IsHasPackage"  @change="changeJDHCIsPackage">
            <el-radio :label="true">是</el-radio>
            <el-radio :label="false">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="包装描述：">
          <el-select :disabled="!applyJDHCForm.IsHasPackage" v-model="applyJDHCForm.PackageDesc">
            <el-option v-for="(item, index) in jdhcAfterPackageDesc" :key="index" :value="item.value"
                       :label="item.title"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="联系人：">
          <el-input v-model="applyJDHCForm.Customer.CustomerContactName"></el-input>
        </el-form-item>
        <el-form-item label="联系电话：">
          <el-input v-model="applyJDHCForm.Customer.CustomerTel"></el-input>
        </el-form-item>
        <el-form-item label="联系手机号码：">
          <el-input v-model="applyJDHCForm.Customer.CustomerMobilePhone"></el-input>
        </el-form-item>
        <el-form-item label="取件方式：">
          <el-select v-model="applyJDHCForm.Pickware.PickwareType">
            <el-option :value="4" label="上门取件"></el-option>
            <el-option :value="7" label="客户送货"></el-option>
            <el-option :value="40" label="客户发货"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="取件地区:">
          <!-- 省 -->
          <el-select
                  v-model="provinceName"
                  placeholder="请选择省"
                  @change="handleProvince"
                  style="width: 150px;"
          >
            <el-option
                    v-for="item in provinceList"
                    :key="item.Id"
                    :label="item.AreaName"
                    :value="item"
            ></el-option>
          </el-select>
          <!-- 市 -->
          <el-select v-model="cityName" placeholder="请选择市" @change="handleCity" style="width: 150px;">
            <el-option v-for="item in cityList" :key="item.Id" :label="item.AreaName"
                       :value="item"></el-option>
          </el-select>
          <!-- 区 -->
          <el-select v-model="countyName" placeholder="请选择区" @change="handleArea" style="width: 150px;">
            <el-option v-for="item in areaList" :key="item.Id" :label="item.AreaName"
                       :value="item"></el-option>
          </el-select>
          <!-- 街道 -->
          <el-select
                  v-model="townName"
                  placeholder="请选择街道"
                  @change="handleStreet"
                  style="width: 150px;"
          >
            <el-option v-for="item in streetList" :key="item.Id" :label="item.AreaName"
                       :value="item"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="取件地址：">
          <el-input v-model="applyJDHCForm.Pickware.PickwareAddress" style="width: 270px;"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button type="primary" v-preventClick @click="submitJdCH">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import toolbar from "../../../components/Toolbar";
import {
  afterSaleOrderList, afterExportList,
  GetAfterSaleOrderSupList,
  BusinessAdopt,
  getQiniuToken,
  SubmitSupData,
  AfterSaleOrderSubmitAudit,
  logisticsCompanyAllList,
  AfterSaleOrderLogisticsAdd,
  AfterSaleOrderLogisticsList,
  AfterSaleOrderUnSubmitAudit,
  businessRefuse,
  JDCtpIsCanApply,
  JDCtpGetApplyReason,
  JDCtpCreateAfsApply,
  JDHCIsCanApply, OrderAfterSaleErpList, AfterSaleOrderAuditRefuse,
} from "../../../api/api";
import { getButtonList } from "../../../promissionRouter";
export default {
  components: { toolbar},
  data() {
    return {
      dialogInfoVisible: false,
      dialogBackLogistic: false,
      dialogExchangeLogistic: false,
      form: {
        pageIndex: 1,
        pageSize: 10,
        Type: 3,
        PurchaseSaleStatus: -1,
        HandleStatus: -1,
        RefundStatus: -1,
        OrderNo: null,
        ApplyUser: null,
        SupReturnPayStatus: -1,
        FinanceStatus: -1,
        ApplyTimeStart: null,
        ApplyTimeEnd: null,
      },
      loading: false,
      itemData: null,
      orderList: [],
      total: 0,
      valueTime: null,

      refundVisible: false,

      buttonList_table: [],
      buttonList_toolBar: [],
      activeName: "second",
      childUpdate1: true,
      childUpdate2: false,
      afterSaleOrderSup: [],
      afterSaleOrderId: null,
      qiniuToken: '',
      infoForm: {
        id: null,
        inspectionSheePic: null,
        supReceiptPic: null,
        externalOrderId: null,
        remark: '',
        supReturnPayMode: 1
      },
      logisticsList: [],
      logisticRecord: [],
      logisticForm: {
        afterSaleOrderId: null,
        supId: null,
        type: null,
        logisticsCompanyId: null,
        logisticsCode: null,
        number: null
      },
      dialogTitle: '退回物流',
      applySkuNumber: 0,
      dialogCtpVisible1: false,
      dialogCtpVisible3: false,
      ctpAfterSaleType: [],
      ctpAfterSaleReason: [],
      applyCtpForm: {
        afsType: null,
        applyReasonId: null,
        applyReasonName: null,
        needUploadPic: null,
        quantity: 1,
        questionPic: null,
        isReceived: false,
        pickWareType: null,
        address: ''
      },
      PicInfoList: [],

      provinceList: [],
      cityList: [],
      areaList: [],
      streetList: [],

      provinceName: null,
      cityName: null,
      countyName: null,
      townName: null,

      provinceId: null,
      cityId: null,
      countyId: null,
      townId: null,
      thiredOrderType: 7,
      jdhcAfterSaleType: [{title:"换货",value: 20}],
      jdhcAfterPackageDesc: [{title:"无包装",value: 0},{title:"包装完整",value: 10},{title:"包装破损",value: 20}],
      applyJDHCForm:{
        AfterSaleOrderId:0,//售后订单ID
        SkuNum:0,//商品申请数量(必填)
        CustomerExpect: 10,//售后类型(必选) ：退货(10)、换货(20)
        QuestionDesc: '',//产品问题描述，最多1000字符
        IsNeedDetectionReport: false,//是否需要检测报告(必选)
        QuestionPic: [],//问题描述图片  数组
        IsHasPackage: false,//是否有包装(必选)
        PackageDesc: 0,//包装描述(必选):0 无包装 10 包装完整 20 包装破损
        Customer:{
          CustomerContactName:'',// 联系人(必填)，最多50字符
          CustomerTel: '',//联系电话(必填)，最多50字符
          CustomerMobilePhone: '',//CustomerMobilePhone
        },
        Pickware:{
          PickwareType:4,//取件方式(必选)：4上门取件； 7 客户送货；40客户发货
          PickwareProvince:null, //取件省(必选)
          PickwareCity:null,//取件市(必选)
          PickwareCounty:null,//取件县(必选)
          PickwareVillage:null,//取件乡镇(必选)
          PickwareAddress:null,//取件街道地址(必填)
        }
      },
    };
  },
  created() {
    this.getAfterSaleOrderList();
  },
  methods: {
    handleBusinessPic(file) {
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils
        .uploadImgToQiniu(file.raw, qiniuData)
        .then((res) => {
          let itemPic;
          if (that.PicInfoList[0]) {
            itemPic = res
          } else {
            itemPic = res
          }
          that.PicInfoList.push(itemPic);
        })
        .catch((err) => {
          that.$message.error(err);
        });
    },
    handleBigPic(src) {
      this.dialogBigImgVisible = true;
      this.dialogImageUrl = src;
    },
    handleDelPic(index) {
      let that = this;
      that.PicInfoList.splice(index, 1);
    },
    keplerCancelBtn(row){
      this.afterSaleOrderId = row.Id
      this.thiredOrderType = row.ThiredOrderType
      this.getQiniuToken()
      this.PicInfoList = []
      if (this.thiredOrderType == 1) {//京东慧采售后
        this.applyJDHCForm.AfterSaleOrderId = row.Id
        // this.dialogJdTitle = "慧采申请售后"
        this.dialogCtpVisible3 = true//售后弹框
        this.getProvinceList()
      } else {//开普勒 7-11
        JDCtpIsCanApply({
          afterSaleOrderId: row.Id
        }).then(res => {
          if (res.data.success) {
            this.dialogCtpVisible1 = true
            this.ctpAfterSaleType = res.data.response
          } else {
            if (RegExp(/不可发起售后/).test(res.data.msg)) {
              this.dialogCtpVisible2 = true
            } else {
              this.$message.error(res.data.msg)
            }
          }
        })
      }
    },
    changeAfsType(val){
      this.applyCtpForm.afsType = val
      this.getJDCtpGetApplyReason(val)
    },
    getJDCtpGetApplyReason(val){
      let params = {
        afterSaleOrderId: this.afterSaleOrderId,
        afsType: val
      }
      JDCtpGetApplyReason(params).then(res => {
        if(res.data.success){
          this.ctpAfterSaleReason = res.data.response
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    changeCtpReason(val){
      this.applyCtpForm.applyReasonId = val.ApplyReasonId
      this.applyCtpForm.applyReasonName = val.ApplyReasonName
      this.applyCtpForm.needUploadPic = val.NeedUploadPic
      if(!val.NeedUploadPic){
        this.PicInfoList = []
      }
    },
    submitCtpAfterSale(){
      if(!this.applyCtpForm.afsType){
        return this.$message.error('请选择售后类型！')
      }
      if(!this.applyCtpForm.applyReasonId){
        return this.$message.error('请选择售后申请问题！')
      }
      if(!this.applyCtpForm.quantity){
        return this.$message.error('请选择售后申请数量！')
      }
      let data = {
        provinceName: this.provinceName,
        cityName: this.cityName,
        countyName: this.countyName,
        townName: this.townName,
        address: this.applyCtpForm.address
      }
      let params = {
        afterSaleOrderId: this.afterSaleOrderId,
        afsType: this.applyCtpForm.afsType,
        applyReasonName: this.applyCtpForm.applyReasonName,
        applyReasonId: this.applyCtpForm.applyReasonId,
        quantity: this.applyCtpForm.quantity,
        isReceived: this.applyCtpForm.isReceived,
        questionPic: this.PicInfoList.join(',')
      }
      if(this.applyCtpForm.isReceived){
        params.pickWareType = this.applyCtpForm.pickWareType
        params.address = data
      }
      JDCtpCreateAfsApply(params).then(res =>{
        if(res.data.success){
          this.getAfterSaleOrderList()
          this.dialogCtpVisible1 = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },

    submitJdCH(){//京东慧采退换货
      this.applyJDHCForm.Pickware.PickwareProvinceName = this.provinceName
      this.applyJDHCForm.Pickware.PickwareCityName = this.cityName
      this.applyJDHCForm.Pickware.PickwareCountyName = this.countyName
      this.applyJDHCForm.Pickware.PickwareVillageName = this.townName
      this.applyJDHCForm.Pickware.PickwareProvince = this.provinceId
      this.applyJDHCForm.Pickware.PickwareCity = this.cityId
      this.applyJDHCForm.Pickware.PickwareCounty = this.countyId
      this.applyJDHCForm.Pickware.PickwareVillage = this.townId
      this.applyJDHCForm.QuestionPic = this.PicInfoList
      if(this.applyJDHCForm.Pickware.PickwareProvince == null || this.applyJDHCForm.Pickware.PickwareCity == null
              || this.applyJDHCForm.Pickware.PickwareCounty == null || this.applyJDHCForm.Pickware.PickwareVillage == null || this.applyJDHCForm.Pickware.PickwareAddress == null){
        return this.$message.error('请输入取件信息！')
      }
      JDHCIsCanApply(this.applyJDHCForm).then(res=>{
        if (res.data.success) {
          this.getAfterSaleOrderList()
          this.dialogCtpVisible3 = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    handleRadio(value, item){
      if(value === 4){
        this.$set(item, 'Freight', 0)
      }
    },
    handleExchangeType(value, item){
      if(value != 3){
        item.ExchangeModelCode = ''
      }
    },
    refuseBtn(row){
      this.$prompt("拒绝原因：", "确认拒绝审核吗", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      }).then(({ value }) => {
        var param = {
          id: row.id,
          reason: value,
        };
        AfterSaleOrderAuditRefuse(param).then((res) => {
          if (res.data.success) {
            this.$message.success("操作成功");
            this.getAfterSaleOrderList()
          } else {
            this.$message.error(res.data.msg)
          }
        });
      });
    },
    cancelBtn(row){
      let list = []
      list.push(row.Id)
      this.$confirm("确认取消吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        AfterSaleOrderUnSubmitAudit({
          afterSaleOrderIds: list
        }).then(res => {
          if(res.data.success){
            this.$message.success(res.data.msg)
            this.getAfterSaleOrderList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    backLogistic(row2, row){
      this.dialogTitle = '退回物流'
      this.dialogBackLogistic = true
      this.logisticForm = {
        afterSaleOrderId: row.Id,
        supId: row2.SupId,
        type: 1,
        logisticsCompanyId: null,
        logisticsCode: null,
        number: null
      }
      this.getAfterSaleOrderLogisticsList()
      logisticsCompanyAllList().then((res) => {
        this.logisticsList = res.data.response;
      });
    },
    exchangeLogistic(row2, row){
      this.dialogTitle = '换货物流'
      this.dialogBackLogistic = true
      this.logisticForm = {
        afterSaleOrderId: row.Id,
        supId: row2.SupId,
        type: 2,
        logisticsCompanyId: null,
        logisticsCode: null,
        number: null
      }
      this.getAfterSaleOrderLogisticsList()
      logisticsCompanyAllList().then((res) => {
        this.logisticsList = res.data.response;
      });
    },
    submitLogistic(){
      AfterSaleOrderLogisticsAdd(this.logisticForm).then(res => {
        if(res.data.success){
          this.$message.success(res.data.msg)
          this.getAfterSaleOrderLogisticsList()
          this.logisticForm.logisticsCompanyId = null
          this.logisticForm.logisticsCode = null
          this.logisticForm.number = null
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    getAfterSaleOrderLogisticsList(){
      let params = {
        afterSaleOrderId: this.logisticForm.afterSaleOrderId,
        supId: this.logisticForm.supId,
        type: this.logisticForm.type,
      }
      AfterSaleOrderLogisticsList(params).then(res => {
        if(res.data.success){
          this.logisticRecord = res.data.response || []
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    submitApproval(row){
      let list = []
      list.push(row.Id)
      this.$confirm("提交审批吗", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        closeOnClickModal: false,
        type: "warning",
      }).then(() => {
        AfterSaleOrderSubmitAudit({
          afterSaleOrderIds: list
        }).then(res => {
          if(res.data.success){
            this.$message.success(res.data.msg)
            this.getAfterSaleOrderList()
          } else {
            this.$message.error(res.data.msg)
          }
        })
      })
    },
    submitInfo(){
      SubmitSupData(this.infoForm).then(res => {
        if(res.data.success){
          this.$message.success(res.data.msg)
          this.dialogInfoVisible = false
          this.getAfterSaleOrderList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    openInfoDialog(row){
      this.getQiniuToken()
      this.dialogInfoVisible = true
      this.infoForm = {
        id: row.Id,
        inspectionSheePic: null,
        supReceiptPic: null,
        externalOrderId: null,
        remark: '',
        supReturnPayMode: 1
      }
    },
    //获取七牛token
    getQiniuToken() {
      var that = this;
      getQiniuToken().then((res) => {
        if (res.data.success) {
          that.qiniuToken = res.data.response;
        } else {
          that.$message.error(res.data.msg);
        }
      }).catch(() => {});
    },
    handleChange(file, i){
      // console.log(i,file,'WWWWWWW')
      let that = this;
      let fileSuf = file.name.split(".")[1];
      let qiniuData = {
        key: `KSAX/System/image/${new Date().getTime()}.${fileSuf}`,
        token: that.qiniuToken,
      };
      that.$utils.uploadImgToQiniu(file.raw, qiniuData).then((res) => {
        if(i == 1){
          that.$set(that.infoForm, 'inspectionSheePic', res)
        } else if(i == 2){
          that.$set(that.infoForm, 'supReceiptPic', res)
        }
      }).catch((err) => {
        that.$message.error(err);
      });
    },
    delPic(i){
      if(i == 1){
        this.infoForm.inspectionSheePic = null
      } else {
        this.infoForm.supReceiptPic = null
      }
    },
    handleSupbox(value, item){
      item.IsChecked = value
    },
    submitAfter(){
      let list = []
      if(this.afterSaleOrderSup.length > 0){
        let checkedList = this.afterSaleOrderSup.filter(item => {
          return item.IsChecked
        })
        if(checkedList.length <= 0){
          return this.$message.error('请勾选要操作的供应商！')
        }
        let flag = checkedList.every(item => {
          return item.DeliveredNumber > 0 
        })
        if(!flag){
          return this.$message.error('换货数量必须大于零！')
        }
        checkedList.forEach(item => {
          list.push({
            supId: item.BuySupplierId,
            freight: item.Freight,
            bearFreight: item.BearFreight,
            deliveredNumber: item.DeliveredNumber,
            exchangeType: item.ExchangeType,
            isNeedSubmitData: item.IsNeedSubmitData,
            remark: item.Remark,
            exchangeModelCode: item.ExchangeModelCode
          })
        })
      }
      let params = {
        afterSaleOrderId: this.afterSaleOrderId,
        afterSaleOrderSupList: list
      }
      BusinessAdopt(params).then(res => {
        if(res.data.success){
          this.$message.success(res.data.msg)
          this.refundVisible = false
          this.getAfterSaleOrderList()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    passBtn(row){
      this.afterSaleOrderId = row.id
      this.applySkuNumber = row.applySkuNumber
      GetAfterSaleOrderSupList({
        childOrderId: row.childOrderId
      }).then(res => {
        if(res.data.success){
          this.refundVisible = true
          let list = res.data.response || []
          list.forEach(item => {
            item.freight = null
            item.bearFreight = 1
            item.deliveredNumber = 1
            item.exchangeType = 1
            item.isNeedSubmitData = true
            item.isChecked = false
            item.remark = ''
            item.exchangeModelCode = ''
          });
          this.afterSaleOrderSup = list
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    setCellStyle({ row, column, rowIndex, columnIndex }) {
      if(columnIndex === 6){
        return 'buyStyle'
      }
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if(columnIndex === 6){
        return [1, 9]
      } else if(columnIndex === 7){
        return [0, 0]
      } else if(columnIndex === 8){
        return [0, 0]
      } else if(columnIndex === 9){
        return [0, 0]
      } else if(columnIndex === 10){
        return [0, 0]
      } else if(columnIndex === 11){
        return [0, 0]
      } else if(columnIndex === 12){
        return [0, 0]
      } else if(columnIndex === 13){
        return [0, 0]
      } else if(columnIndex === 14){
        return [0, 0]
      }
    },
    handleClick() {
      if(this.activeName === 'first'){
        this.$router.push('/AfterSalesService/AfterSaleList/Index1')
      }
    },
    getAfterSaleOrderList() {
      let that = this;
      that.loading = true;
      OrderAfterSaleErpList(that.form).then((res) => {
        that.loading = false;
        that.orderList = res.data.response.data;
        that.total = res.data.response.dataCount;
        that.refundVisible = false;
      });
    },
    handlePicker(e) {
      this.form.ApplyTimeStart = e[0];
      this.form.ApplyTimeEnd = e[1];
    },
    callFunction(item) {
      this[item.Func](item);
    },
    callFunctionRow(item, index, row) {
      this[item.Func](item, index, row);
    },
    handleCurrentChange(val) {
      this.form.pageIndex = val;
      this.getAfterSaleOrderList();
    },
    handleSizeChange(e) {
      this.form.pageSize = e;
      this.getAfterSaleOrderList();
    },
    onSubmit() {
      this.form.pageIndex = 1;
      this.getAfterSaleOrderList();
    },
    onEmpty() {
      this.form = {
        pageIndex: 1,
        pageSize: 10,
        Type: 3,
        PurchaseSaleStatus: -1,
        HandleStatus: -1,
        RefundStatus: -1,
        OrderNo: null,
        ApplyUser: null,
        SupReturnPayStatus: -1,
        FinanceStatus: -1,
        ApplyTimeStart: null,
        ApplyTimeEnd: null,
      };
      this.valueTime = []
    },
    handleExp() {
      let that = this;
      afterExportList(that.form).then((res) => {
        if (res.data.success) {
          that.$message.success('操作成功，请点击下载中心查看下载结果');
        } else {
          that.$message.error(res.data.msg);
        }
      });
    },
    handleDetail(item, index, row) {
      this.$router.push(`/Order/AfterSales/AfterSalesDetail?id=${row.Id}`)
    },
    //获取省
    getProvinceList() {
      let that = this;
      areaList({areaLevel: 1}).then((res) => {
        that.provinceList = res.data.response;
      });
    },
    //获取市
    getCityList(id) {
      let that = this;
      let params = {
        areaLevel: 2,
        parentId: id ? id : that.provinceId,
      };
      areaList(params).then((res) => {
        that.cityList = res.data.response;
      });
    },
    //获取区
    getAreaList(id) {
      let that = this;
      let params = {
        areaLevel: 3,
        parentId: id ? id : that.cityId,
      };
      areaList(params).then((res) => {
        that.areaList = res.data.response;
      });
    },
    //获取街道
    getStreetList(id) {
      let that = this;
      let params = {
        areaLevel: 4,
        parentId: id ? id : that.countyId,
      };
      areaList(params).then((res) => {
        that.streetList = res.data.response;
      });
    },
    //选择省市区
    handleProvince(e) {
      let that = this;
      that.provinceName = e.AreaName;
      that.cityName = null;
      that.countyName = null;
      that.townName = null;
      that.provinceId = e.Id;
      that.cityId = null;
      that.countyId = null;
      that.townId = null;
      that.getCityList(e.Id);
    },
    handleCity(e) {
      let that = this;
      that.cityName = e.AreaName;
      that.countyName = null;
      that.townName = null;
      that.cityId = e.Id;
      that.countyId = null;
      that.townId = null;
      that.getAreaList(e.Id);
    },
    handleArea(e) {
      let that = this;
      that.countyName = e.AreaName;
      that.townName = null;
      that.countyId = e.Id;
      that.townId = null;
      that.getStreetList(e.Id);
    },
    handleStreet(e) {
      let that = this;
      that.townName = e.AreaName;
      that.townId = e.Id;
    }
  },
  mounted() {
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    var buttonList = getButtonList(this.$route.path, routers);
    const toolBarButtonList = buttonList.filter((item) => {
      return item.buttonShow === 10;
    });
    this.buttonList_toolBar = toolBarButtonList;
    const tableButtonList = buttonList.filter((item) => {
      return item.buttonShow === 20;
    });
    this.buttonList_table = tableButtonList;
  },
};
</script>

<style scoped>
.aftersales_main {
  padding: 0 20px 20px 20px;
}
.el-input{
  width: 240px;
}
.el-textarea{
  width: 240px;
}
.item-sup{
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}
.item-sup-l{
  margin-right: 6px;
}
.btm{
  margin-bottom: 10px;
}
.mar-r{
  margin-right: 20px;;
}
.img-box{
  display: block;
  text-align: center;
}
.img-box .el_upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  width: 150px;
  height: 150px;
}
.img-box .el_upload:hover {
  border-color: #409eff;
}
.img-box .el_upload:hover .mask {
  opacity: 1;
}

.img-box .mask {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
  cursor: default;
  text-align: center;
  line-height: 150px;
  color: #fff;
  opacity: 0;
  font-size: 20px;
  background-color: rgba(0, 0, 0, 0.5);
  transition: opacity 0.3s;
}
.img-box .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 150px;
  height: 150px;
  line-height: 150px!important;
  text-align: center;
}
.img-box .avatar {
  width: 150px;
  height: 150px;
}
</style>
<style>
.buyStyle{
  padding: 0 !important;
}
.buyStyle .cell{
  padding: 0 !important;
}
</style>
